import { createStitches } from '@stitches/react';

const { keyframes, styled } = createStitches();

export { keyframes, styled };
//# sourceMappingURL=stitches.config.es.js.map
